<div class="full-width-image-section caravan-top">
    <div class="arrow-up">
        <next-topbar></next-topbar>
        <next-menu></next-menu>

        <div class="container white">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h1>{{ 'INSURANCE.CARAVAN.COMPONENTS.INDEX.TITLE' | translate }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 col-sm-offset-4">
                    <div class="icon-bg center">
                        <div class="icon-wrap">
                            <i class="nf nf-caravan-icon-v3"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm-12 text-center">
            <br />
            <br />
            <calculate-btn [gotoLink]="navigationService.getUrl('calculate-caravan')" [productName]="'INSURANCE.CARAVAN.PRODUCT' | translate | uppercase"></calculate-btn>
            <br />
            <br />
        </div>
    </div>
</div>

<caravan-cover></caravan-cover>

<trustpilot-carousel></trustpilot-carousel>

<div class="gray-bg">
    <div class="container">
        <next-faqarticle [category]="'FAQ_CARAVAN'"></next-faqarticle>
    </div>
</div>

<nicetoknow [pagecode]="'INSURANCE_CARAVAN_NICETOKNOW'"></nicetoknow>

<next-footer></next-footer>
